import React, { useEffect, useState } from 'react'
import { MainContainer } from '../../../constants/component.constants'
import UserDetailsCard from '../../../components/cards/userDetailsCard'
import { getLoggedInUser, getLoggedInUserEmailNotifications, getLoggedInUserNotifications, updateUserData } from '../../../services/profile.service';
import { isEmptyString, isNullUndefined, isValidPhoneNumber, isValidEmail } from '../../../util/util';
import {useDispatch, useSelector} from 'react-redux';
import { issueResponseMessage, issueWarnMessage } from '../../../actions/message';
import { resetProfilePassword } from '../../../services/passwords.service';
import { ResponsiveRow } from '../../../constants/layout.constants';
import {useNavigate} from "react-router-dom";
import {logout} from "../../../actions/auth";

export default function ListProfile() {

    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [notification, setNotification] = useState(null);
    const user = useSelector((state) => state.auth.user);
    const [emailNotification, setEmailNotification] = useState(null)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true)
        getLoggedInUser()
            .then((user) => {
                setSelectedUser(user)
            })
        getLoggedInUserNotifications()
            .then((notification) => {
                setNotification(notification)
            })
            .finally(() => {
                setLoading(false)
            })
        if (!isEmptyString(user.proxyFacility)) {
            getLoggedInUserEmailNotifications()
                .then((notification) => {
                    setEmailNotification(notification)
                })
        }
    }, [])


    /** Resolves true only when the details were saved, so the card knows
     *  whether it may collapse the section. */
    function handleUpdatePersonDetailsClick(selectedUser) {
        const {isValid, errors} = isValidPhoneNumber(selectedUser?.mobilePhone)
        if(!isValid){
            issueWarnMessage(
                `Mobile phone number is invalid. ${errors.join('. ')}`
            );
            return false;
        }

        if(selectedUser?.officePhone) {
            if(selectedUser?.officePhone === selectedUser?.mobilePhone) {
                issueWarnMessage(
                    `Office phone number cannot be same as mobile phone number. Leave blank if you don't have a separate phone number.`
                );
                return false;
            }
            const {isValid, errors} = isValidPhoneNumber(selectedUser?.officePhone)
            if(!isValid){
                issueWarnMessage(
                    `Office phone number is invalid. ${errors.join('. ')}`
                );
                return false;
            }
        }
        if (!isEmptyString(selectedUser?.email) && !isValidEmail(selectedUser.email)) {
            issueWarnMessage("Please enter a valid email address.");
            return false;
        }
        const userName = String(selectedUser?.username ?? "").replace(/"/g, "")
        if (isEmptyString(userName)) {
            issueWarnMessage("Could not determine username. Please refresh the page.");
            return false;
        }
        const user = { ...selectedUser, credentialId: userName }
        delete user.username
        // A rejected save resolves undefined: the service reports the error and
        // swallows the rejection, so an absent response means "not saved".
        return updateUserData(user)
            .then((response) => {
                if (!response) return false
                issueResponseMessage(response)
                if(response.forceLogout) {
                    setTimeout(() => {
                        dispatch(logout());
                        navigate("/listings/signIn");
                    }, 3000)
                } else {
                    getUser();
                }
                return response.type === "success"
            })
    }

    function getUser() {
        setLoading(true)
        getLoggedInUser()
            .then((user) => {
                setSelectedUser(user)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function handleUpdatePasswordClick(paramsValue) {
        let user = selectedUser
        let params = paramsValue
        let userName = user.username.replace(/"/g, "")
        params.username = userName
        resetProfilePassword(params)
            .then((response) => {
                if (!response) return
                issueResponseMessage(response)
                if (response.forceLogout) {
                    setTimeout(() => {
                        dispatch(logout());
                        navigate("/listings/signIn");
                    }, 3000)
                }
            })
    }


  return (
    <MainContainer >
        <ResponsiveRow id='oned' item sx={{width: { xs: "98%", lg: "80%" }, margin: "5rem auto", justifyContent: "center" }}>
            {!isNullUndefined(selectedUser) && !isNullUndefined(notification) && 
            <UserDetailsCard
                userExpanded = {true}
                selectedUser={selectedUser}
                notification={notification}
                hideEmail = {true}
                hideReport = {true}
                loading={loading}
                handleUpdatePersonDetailsClick={handleUpdatePersonDetailsClick}
                handleUpdatePasswordClick={handleUpdatePasswordClick}
            /> }
        </ResponsiveRow>
    </MainContainer>
  )
}
